<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>ADD_ORDER_ROW</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th translate>ITEM_NO</th>
              <th translate>QUANTITY</th>
              <th translate>PRICE</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of modalRows; let rowIndex = index">
              <td width="20%">
                <jeeves-product-select-dropdown
                  (productSelected)="selectProduct($event, rowIndex)"
                  [formatterFunction]="productSearchFormatter"
                  [formatterInputFunction]="productSearchInputFormatter"
                ></jeeves-product-select-dropdown>
              </td>
              <td>
                <input
                  class="form-control"
                  type="number"
                  [(ngModel)]="row.qty"
                  (change)="validateQuantity(row.qty, rowIndex)"
                />
              </td>
              <td>
                <input class="form-control" type="number" [(ngModel)]="row.price" />
              </td>
              <td width="5%">
                <i class="fa fa-trash-alt clickable" (click)="removeRow(rowIndex)"></i>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <button class="btn btn-primary btn-block" (click)="addNewRow()" translate>ADD_ORDER_ROW</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button *ngIf="true" type="button" class="btn btn-primary" (click)="submitRows()" translate>ADD_ORDER_ROW</button>
</div>
